import { render, staticRenderFns } from "./CreditNoteView.vue?vue&type=template&id=6b2b0bb2&scoped=true"
import script from "./CreditNoteView.vue?vue&type=script&lang=js"
export * from "./CreditNoteView.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteView.vue?vue&type=style&index=0&id=6b2b0bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b0bb2",
  null
  
)

export default component.exports